import AngleCirculeRight from "shared/components/utils/icons/AngleCirculeRight";
import DownArrow from "shared/components/utils/icons/DownArrow";
import PropTypes from "prop-types";
import {
    IndentColumn,
    DataColumn,
    WrapperClient,
    Wrapper,
    ClientLabel,
    ButtonWrapper,
} from "./ClientHeader.styles";

const ClientHeader = ({ name, isOpen, onToggleClick, id }) => {
    return (
        <Wrapper id={`wrapper_client_${name}`}>
                <IndentColumn xs={1} />
                <DataColumn id={`col_client_${name}`}>
                    <WrapperClient id={`div_client_${name}`}>
                        <ButtonWrapper>
                            <button
                                id={`ico1_client_${id}`}
                                type="button"
                                onClick={onToggleClick}
                                style={{ display: isOpen ? "" : "none", background: "none", border: "none", padding: 0, cursor: "pointer" }}
                            >
                                <DownArrow color={globalThis.config.colors.black} size="12px" />
                            </button>

                            <button
                                id={`ico2_client_${id}`}
                                type="button"
                                onClick={onToggleClick}
                                style={{ display: isOpen ? "none" : "", background: "none", border: "none", padding: 0, cursor: "pointer" }}
                            >
                                <AngleCirculeRight size="12px" />
                            </button>
                        </ButtonWrapper>
                        <div style={{ marginTop: "-2px" }}>
                            <ClientLabel>{name}</ClientLabel>
                        </div>
                    </WrapperClient>
                </DataColumn>
        </Wrapper>
    );
};

ClientHeader.propTypes = {
    name: PropTypes.string.isRequired,
    isOpen: PropTypes.bool,
    onToggleClick: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
};

export default ClientHeader;
